import { Component, OnInit, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { APP_MAT_DATE_FORMAT } from './format-datepicker';
import {provideMomentDateAdapter} from "@angular/material-moment-adapter";

@Component({
    selector: 'app-input-calendar',
    templateUrl: './input-calendar.component.html',
    styleUrls: ['./input-calendar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [provideMomentDateAdapter(APP_MAT_DATE_FORMAT)],
    standalone: false
})
export class InputCalendarComponent implements OnInit {
  private localDateMin: Date | null;
  private localDateMax: Date | null;

  @Input() name: string;
  @Input() withImage: boolean;
  @Input() dateTimeRange: any;
  @Input() selectMode: string;
  @Input() startingPlaceholder: string;
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() isValid = true;
  @Input() isValidMessage = '';
  @Output() dateTimeRangeChange = new EventEmitter();
  @Output() saveModel = new EventEmitter();
  @Input() required: boolean;
  @Input()
  set minDate(date: Date | null) {
    if (date) {
      const temp = new Date(date);
      temp.setDate(temp.getDate() + 1);
      this.localDateMin = temp;
    } else {
      this.localDateMin = null;
    }
  }
  get minDate(): Date | null {
    return this.localDateMin;
  }

  @Input()
  set maxDate(date: Date | null) {
    if (date) {
      const temp = new Date(date);
      temp.setDate(temp.getDate() - 1);
      this.localDateMax = temp;
    } else {
      this.localDateMax = null;
    }
  }
  get maxDate(): Date | null {
    return this.localDateMax;
  }

  value: Date;
  oldValue: Date;
  oldRange: any;
  pickerOpen: boolean;

  constructor() {}

  onChange(): void {
    this.dateTimeRangeChange.emit(this.dateTimeRange);
  }

  afterPickerOpen(): void {
    this.pickerOpen = true;
  }

  onSaveModel(): void {
    if (this.selectMode === 'range') {
      if (JSON.stringify(this.dateTimeRange) !== JSON.stringify(this.oldRange)) {
        this.saveModel.emit();
      }
    } else {
      if (this.oldValue !== this.dateTimeRange) {
        this.saveModel.emit();
      }
    }
  }

  onSaveState(): void {
    if (this.selectMode === 'range') {
      if (!this.pickerOpen) {
        this.oldRange = this.dateTimeRange;
      }
    } else {
      this.oldValue = this.dateTimeRange;
    }
  }

  ngOnInit(): void {
    this.onSaveState();
  }

  onInputCheckEmpty($event: any): void {
    $event; // Avoid unused variable warning
  }
}
